'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teachingPopoverCarouselClassNames: function() {
        return teachingPopoverCarouselClassNames;
    },
    useTeachingPopoverCarouselStyles_unstable: function() {
        return useTeachingPopoverCarouselStyles_unstable;
    }
});
const _react = require("@griffel/react");
const teachingPopoverCarouselClassNames = {
    root: 'fui-TeachingPopoverCarousel'
};
// Todo: Page change animation & styles
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {}
}, {});
const useTeachingPopoverCarouselStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(teachingPopoverCarouselClassNames.root, styles.root, state.root.className);
    return state;
};
